import { Link } from "react-router-dom";
import "./Profile.scss";
import React, { useState } from "react";
import { changePassword } from "../../../components/Axios/Axios";
import { toast, ToastContainer } from "react-toastify";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import UserService from "../../../services/user.service";
import { useAppDispatch } from "../../../hooks/app";
import { setUser } from "../../../store/slices/auth-slice";
import BackupService from "../../../services/backup.service";
import useFileDownload from "../../../hooks/useFileDownload";
function Profile() {
  const [showPass, setShow] = React.useState(false);
  const [username, setUserName] = React.useState("");
  const [firstname, setFirstName] = React.useState("");
  const [lastname, setLastName] = React.useState("");
  const [signature, setSignature] = React.useState(null);
  const [email, setEmail] = React.useState("");
  const [currentPassword, setCurrentPassword] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  function toggleShow() {
    setShow(!showPass);
  }
  const dispatch = useAppDispatch()
  React.useEffect(() => {
    // Retrieve the stored value from local storage
    const storedUserString = localStorage.getItem('user');

    if (storedUserString) {
      try {
        // Parse the stored JSON string to get the user object
        const user = JSON.parse(storedUserString);

        setUserName(user.username);
        setFirstName(user.firstname)
        setLastName(user.lastname)
        setEmail(user.email)
        console.log('Username:', username);
      } catch (error) {
        console.error('Error parsing stored user data:', error);
      }
    }
  }, []);

  const showToastMessage = (response: any) => {
    toast(
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ padding: "2px", marginRight: "8px" }}>
          <CheckCircleOutlineIcon />
        </div>
        <span>{response}</span>
      </div>,
      {
        position: "top-center",
        autoClose: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        hideProgressBar: true,
        style: {
          textAlign: "center",
          color: "green",
          background: "#edf7ed",
          borderRadius: "8px",
          padding: "10px",
          fontWeight: "bold",
          borderBottom: "5px solid green",
        },
      }
    );

    //CheckCircleOutlineIcon
  };
  const showFailedToastMessage = (response: any) => {
    toast(
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ padding: "2px", marginRight: "8px" }}>
          <ErrorOutlineIcon />
        </div>
        <span>{response}</span>
      </div>,
      {
        position: "top-center",
        autoClose: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        hideProgressBar: true,
        style: {
          textAlign: "center",
          marginRight: "25%",
          maxWidth: "fit-content",
          color: "#CC0000",
          background: "#fdeded",
          borderRadius: "8px",
          padding: "10px",
          fontWeight: "bold",
          borderBottom: "5px solid #CC0000",
        },
      }
    );
  };

  const resetAllStates = () => {
    setCurrentPassword("");
    setNewPassword("");
  };

  const updateProfile = async (e: any) => {
    e.preventDefault()
    console.log(firstname, lastname, signature)
    const formData = new FormData();
    formData.append("firstname", firstname);
    formData.append("lastname", lastname);
    if (signature) {
      formData.append("signature", signature);
    }
    try {
      const res: any = await UserService.updateProfile(formData);
      if (res?.status === 200 && res?.user) {
        localStorage.setItem('user', JSON.stringify(res.user));
        dispatch(setUser(res?.user));
        setSignature(null);
        showToastMessage(res?.message);
      }
    } catch (error: any) {
      console.error(error);
      showFailedToastMessage(error?.response?.data?.message);
    }
  }

  const onSubmitForm = async (e: any) => {
    e.preventDefault();
    try {
      const data2 = {
        username: username,
        currentPassword: currentPassword,
        newPassword: newPassword,
      };
      console.log(data2, "body1 Payload");
      const res = await changePassword(data2);
      showToastMessage(res.message);
      resetAllStates();

    } catch (error: any) {
      console.error(error);
      showFailedToastMessage(error.message);
    }

  };

  return (
    <div style={{ margin: "1%" }}>
      <section style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", paddingTop: "2%" }}>
        <h4 className="dashboard_heading">Profile</h4>
        <h6 className="dashboard_subheading">Dashboard {">"} Profile</h6>
      </section>

      <section className="profile_sec">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "20px", flexWrap: "wrap-reverse" }}>
          <h4 className="heading3" style={{ fontWeight: "600", margin: 0, padding: 0 }} >Edit Personal Details</h4>
        </div>
        <hr className="default_line" />

        <form className="profile_form" onSubmit={updateProfile}>
          <div className="pf_form_group">
            <div className="pf_label"><label>First Name:</label></div>
            <div className="pf_input">
              <input className="input" type="text" placeholder="First Name" name="f_name" value={firstname} required onChange={(e) => setFirstName(e.target.value)} />
            </div>
          </div>
          <div className="pf_form_group">
            <div className="pf_label"><label>Last Name:</label></div>
            <div className="pf_input">
              <input className="input" type="text" placeholder="Last Name" name="l_name" value={lastname} required onChange={(e) => setLastName(e.target.value)} />
            </div>
          </div>
          <div className="pf_form_group">
            <div className="pf_label"><label>User Name:</label></div>
            <div className="pf_input">
              <input className="input" type="text" placeholder="First Name" name="f_name" value={username} required disabled />
            </div>
          </div>
          <div className="pf_form_group">
            <div className="pf_label"><label>Mailing Address:</label></div>
            <div className="pf_input">
              <input className="input" type="email" placeholder="Email" name="email" value={email} required disabled />
            </div>
          </div>
          <div className="pf_form_group">
            <div className="pf_label"><label>Upload Signature:</label></div>
            <div className="pf_input">
              <input className="input" type="file" accept="image/*" name="signature" onChange={(e: any) => setSignature(e.target.files[0])} />
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "end", maxWidth: 570, width: "100%" }}>
            <button className="save_btn" type="submit">Update</button>
          </div>
        </form>


        <h4 className="heading3" style={{ fontWeight: "600", paddingTop: "30px" }} >Password</h4>
        <hr className="default_line" />

        <p>Last sign-in Date:  9/9/2023</p>
        <button className="change_Pass" onClick={toggleShow}>Change Password</button>

        {showPass && (
          <form className="profile_form" onSubmit={onSubmitForm}>
            <div className="pf_form_group">
              <div className="pf_label"><label>Old Password:</label></div>
              <div className="pf_input">
                <input type="password" placeholder="Old Password" name="old_pass" value={currentPassword} required onChange={(e) => setCurrentPassword(e.target.value)} />
              </div>
            </div>
            <div className="pf_form_group">
              <div className="pf_label"><label>New Password:</label></div>
              <div className="pf_input">
                <input type="password" placeholder="New Password" name="new_pass" value={newPassword} required onChange={(e) => setNewPassword(e.target.value)} />
              </div>
            </div>
            {/* <div className="pf_form_group">
                            <div className="pf_label"><label>Confirm Password:</label></div>
                            <div className="pf_input">
                                <input type="password" placeholder="Confirm Password" name="confirm_pass" value="" required />
                            </div>
                        </div> */}
            <button className="save_btn">Change Password</button>
          </form>
        )}
      </section>
      <ToastContainer />
    </div>
  );
}

export default Profile;
